import {
  ErrorDefault,
  RequestDefault,
  ResponseDefault,
} from "../../shared/constant";
import globalUtils from "../../utils/globalUtils";
import labelConstants from "../constants/labelConstants";

const initialState: {
  labels: any[];
  labelCount: number;
  allLabels: any[];
  error: Boolean;
  pending: Boolean;
  fulfilled: Boolean;
  labelsPending: boolean;
} = {
  labels: [],
  labelCount: 0,
  allLabels: [],
  error: false,
  pending: false,
  fulfilled: false,
  labelsPending: false,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case labelConstants.GET_LABELS_LIST:
      return {
        ...state,
        labelsPending: true,
      };
    case labelConstants.GET_LABELS_LIST_SUCCESS:
      if (globalUtils.isResultsExistInObj(action.payload.data))
        return {
          ...state,
          labelsPending: false,
          labels: action.payload.data.results,
          labelCount: action.payload.data.count,
        };
      return { ...state, allLabels: action.payload.data };
    case labelConstants.GET_LABELS_LIST_FAILURE:
      return {
        ...state,
        labelsPending: false,
      };

    case labelConstants.ADD_LABEL_REQ:
    case labelConstants.EDIT_LABEL_REQUEST:
    case labelConstants.DELETE_LABEL_REQUEST:
      return {
        ...state,
        ...RequestDefault,
      };
    case labelConstants.ADD_LABEL_SUCCESS:
    case labelConstants.EDIT_LABEL_SUCCESS:
    case labelConstants.DELETE_LABEL_SUCCESS:
      return {
        ...state,
        ...ResponseDefault,
      };
    case labelConstants.ADD_LABEL_FAILURE:
    case labelConstants.EDIT_LABEL_FAILURE:
    case labelConstants.DELETE_LABEL_FAILURE:
      return {
        ...state,
        ...ErrorDefault,
      };

    case labelConstants.RESET_LABELS:
      return {
        ...state,
        labels: [],
        labelCount: 0,
        allLabels: [],
      };
    default:
      return {
        ...state,
      };
  }
};
